/** @flow */

import React, { Component, type ComponentType } from "react";
import { SectionComponent } from "../section";
import Icons from "../icons";

type OwnProps = {
  title: string | React$Node,
  textNearEdit?: string,
  component: ComponentType<*>,
  rightInfo?: (row: Object) => React$Node,
  isReadonly?: boolean,
  hidden?: boolean,
  hideTitle?: boolean,
  nextButtonLabel?: string,
  // Received from a wizard
  data?: Object,
  editable?: boolean,
  onChange?: (values?: Object, valid?: boolean) => any,
  onError?: (Object[]) => any,
  handleSubmit?: (values: Object, valid: boolean) => any,
  isTouched?: boolean,
  isValid?: boolean,
  isCollapsable?: boolean,
  onToggleEdit?: () => any,
  getStepState?: (step: number) => any,
  step?: number,
  currentStep?: number,
};

const getStepColor = (editable, isTouched, isValid) => {
  if (editable) {
    return "black";
  } else if (isTouched && !isValid) {
    return "negative";
  } else if (!isTouched) {
    return "disabled";
  }
  return "green";
};

class Step extends Component<OwnProps> {
  constructor(props: OwnProps) {
    super(props);
    this.containerRef = React.createRef();
  }

  componentDidUpdate(prevProps: OwnProps) {
    if (this.props.editable && !prevProps.editable && this.containerRef.current) {
      this.containerRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }

  render() {
    const {
      component: Handler,
      title,
      hideTitle,
      onChange,
      onError,
      handleSubmit,
      editable,
      isReadonly,
      data = {},
      isTouched,
      isValid,
      isCollapsable,
      onToggleEdit,
      rightInfo,
      textNearEdit,
      schema,
      uiSchema,
      ...rest
    } = this.props;

    const handler = (
      <Handler
        onChange={onChange}
        onError={onError}
        handleSubmit={handleSubmit}
        editable={editable}
        data={data}
        isTouched={isTouched}
        isValid={isValid}
        isCollapsable={isCollapsable}
        onToggleEdit={onToggleEdit}
        schema={schema}
        uiSchema={uiSchema}
        {...rest}
      />
    );

    if (hideTitle) {
      return handler;
    }

    return (
      <div ref={this.containerRef}>
        <SectionComponent
          title={
            <div className="d-flex">
              {!editable && isTouched && isValid ? (
                <Icons.StepCheckIcon color="positive" />
              ) : (
                <Icons.StepCircleIcon color={getStepColor(editable, isTouched, isValid)} />
              )}
              <h5>{title}</h5>
            </div>
          }
          collapsable={isCollapsable}
          compact
          hoverFeedback
          rightLink={
            !isCollapsable && isTouched && !editable ? (
              <div>
                {rightInfo && <span>{rightInfo(data)}</span>}
                {textNearEdit && (
                  <span className="text-orange small-font-size font-weight-normal mr-2">
                    {textNearEdit}
                  </span>
                )}
                {isValid && !isReadonly && (
                  <span onClick={onToggleEdit} className="material-icons pointer font-size-34 pr-3">
                    edit
                  </span>
                )}
              </div>
            ) : null
          }
          active={!isCollapsable && editable}
          disabled={!editable && !isTouched}
          isOpen={isCollapsable ? editable : true}
          onTitleClick={isCollapsable ? onToggleEdit : undefined}
          defaultBorder
        >
          {handler}
        </SectionComponent>
      </div>
    );
  }
}

export default Step;
